<template>
  <div v-if="category && discipline">
    <div v-if="customTitle" class="print-title-section">
      <h2 class="print-title">{{ customTitle }}</h2>
      <div class="competitor-count">Ukupno takmičara: {{ data.length }}</div>
    </div>
    <div v-else class="print-title-section">
      <h3>{{ sexString }} | {{ category.name }}</h3>
      <h4> {{ discipline.name }} ({{ data.length }})</h4>
    </div>
    <table>
      <thead>
        <tr>
          <th>{{ $tc("general.n0") }}</th>
          <th v-if="!isTeam">{{ $tc("form.image") }}</th>
          <th>{{ $tc("form.name") }}</th>
          <th v-if="!isTeam">{{ $tc("form.belt") }}</th>
          <th v-if="!isTeam">{{ $tc("form.date_of_birth") }}</th>
          <th>{{ $tc("club.short_name") }}</th>
          <th>{{ $tc("general.placement") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(registration, index) in data" :key="registration.id">
          <td>{{ index + 1 }}.</td>
          <td v-if="!isTeam" style="width: 80px">
            <div class="image">
              <img
                :src="$file('avatars', registration.competitor.avatar)"
                style="width: 75px; height: 75px; object-fit: cover"
                class="image"
              />
            </div>
          </td>
          <td>
            {{ getCompetitorNames(registration, false) }}
          </td>
          <td v-if="!isTeam">{{ registration.competitor.belt | belt }}</td>
          <td v-if="!isTeam">{{ registration.competitor.born | date }}</td>
          <td>
            <span v-if="registration.club && registration.club.logo" class="club-logo-cell">
              <img
                :src="$file('avatars', registration.club.logo)"
                class="club-logo"
                alt=""
              />
            </span>
            {{ registration.club.shortName }}, {{ registration.club.city }}
          </td>
          <td class="placement-cell">
            <span class="placement-box" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { getCompetitors, getCompetitorNames } from './tournament-discipline'

export default {
  props: {
    category: {
      type: Object,
      required: true
    },

    isMale: {
      type: Boolean,
      default: null
    },

    discipline: {
      type: Object,
      required: true
    },

    competitors: {
      type: Array,
      default: () => []
    },

    isTeam: {
      type: Boolean,
      default: false
    },

    preFilteredData: {
      type: Array,
      default: null
    },

    customTitle: {
      type: String,
      default: null
    }
  },

  computed: {
    sexString () {
      if (this.isMale === null) return 'Svi'

      return this.isMale ? 'Muški' : 'Ženski'
    },

    data () {
      // If preFilteredData is provided, use it directly
      if (this.preFilteredData !== null && this.preFilteredData !== undefined) {
        return this.preFilteredData
      }

      if (!this.category || !this.discipline) return []

      const MF = this.isMale ? 'M' : 'F'
      const filter = this.isMale !== null && !this.isTeam ? MF : null

      let competitors = this.competitors
      if (this.isTeam) {
        let filterType = 'WOMEN'
        if (this.isMale === null) filterType = 'MIX'
        else if (this.isMale) filterType = 'MEN'

        competitors = competitors.filter(c => c.type === filterType)
      }

      return getCompetitors(
        this.category.id,
        this.discipline.id,
        competitors,
        filter
      )
    }
  },

  methods: {
    getCompetitorNames
  }
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  page-break-inside: auto;
}

table thead {
  display: table-header-group;
}

table tbody {
  display: table-row-group;
}

table tr {
  page-break-inside: avoid;
  page-break-after: auto;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f2f2f2;
  font-weight: bold;
  white-space: nowrap;
}

.image {
  width: 75px;
  height: 75px;
  object-fit: cover;
}

.club-logo-cell {
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
}

.club-logo {
  width: 32px;
  height: 32px;
  object-fit: contain;
  vertical-align: middle;
}

.placement-cell {
  width: 44px;
  text-align: center;
  vertical-align: middle;
}

.placement-box {
  display: inline-block;
  width: 28px;
  height: 28px;
  border: 1px solid #333;
  background: #fff;
}

.print-title-section {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #333;
}

.print-title {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: bold;
  color: #333;
  line-height: 1.4;
}

.competitor-count {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

@media print {
  table {
    page-break-inside: auto !important;
  }

  tr {
    page-break-inside: avoid !important;
    page-break-after: auto !important;
  }
}
</style>
